import React from 'react';
import '../styles/HeroSection.css';

function HeroSection() {
  return (
    <section id="hero" className="hero-section d-flex align-items-center justify-content-center">
      <div className="hero-content text-center text-white">
        <h1 className="hero-title">أهلاً بكم في محل مناحل المراد</h1>
        <p className="hero-description">
        بخبرة تمتد لأكثر من ثلاثين عامًا في إنتاج وتوريد **عسل المراد الطبيعي النقي**، نقدم لكم منتجًا عالي الجودة يأتي مباشرة من **مناحلنا الخاصة ومركزنا في مدينة حماة، سوريا**. نحن ملتزمون بتقديم أجود أنواع **العسل السوري الأصلي**، لتلبية احتياجاتكم من المنتجات الطبيعية والصحية بأعلى معايير الجودة.</p>

        <a href="#products" className="btn hero-button">تصفح المنتجات</a>
      </div>
    </section>
  );
}

export default HeroSection;
